import { handleActions } from "redux-actions";

import {
  SET_DATES,
  SET_LOADING,
  SET_START_FROM,
  SET_HIDE_ACTIONS,
  SET_TABLE_LOADING,
  SET_FILTER_BY_INDEX,
  SET_FILTERS_LOADING,
  SET_MAIN_FILTER_LOADING,
  SET_START_FROM_BY_INDEX,
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_FILTER_BY_INDEX_SUCCESS,
  FETCH_TABLE_DATA_SUCCESS,
  FETCH_MAIN_FILTER_SUCCESS,
  CREATE_FILTERS_GROUP,
  UPDATE_MAIN_FILTER,
  CHANGE_ORDER,
  REMOVE_FILTERS_GROUP,
  RESET_FILTERS
} from "./leadActivitySagas";

const FILTERS = {
  staff: { id: "staff", name: "Staff" },
  class: { id: "class", name: "Class" },
  day: { id: "day", name: "Day" },
  time: { id: "time", name: "Time" },
  prospect_type: { id: "prospect_type", name: "Prospect Type" },
  referral_source: { id: "referral_source", name: "Referral Source" },
  referral_category: { id: "referral_category", name: "Referral Category" },
  enrollment_type: { id: "enrollment_type", name: "Enrollment Type" },
  revenue_category: { id: "revenue_category", name: "Revenue Category" },
  appointment_booking_date: { id: "booking_date", name: "Log Date" },
  appointment_visit_date: { id: "visit_date", name: "Booking Date" },
  show_booking_date: { id: "booking_date", name: "Log Date" },
  show_visit_date: { id: "visit_date", name: "Visit Date" },
  sale_date: { id: "sale_date", name: "Sale Date" },
  invoice_date: { id: "invoice_date", name: "Invoice Added Date" }
};

const getFilters = (...ids) => ids.map((id) => FILTERS[id]);

const FILTERS_CONFIG = {
  lead: {
    filter_by: getFilters("prospect_type", "referral_source", "referral_category")
  },
  appointment: {
    filter_by: getFilters("staff", "class", "day", "time"),
    date_by: getFilters("appointment_visit_date", "appointment_booking_date")
  },
  show: {
    filter_by: getFilters("staff", "class", "day", "time"),
    date_by: getFilters("show_visit_date", "show_booking_date")
  },
  enrollment: {
    filter_by: getFilters("staff", "enrollment_type", "revenue_category"),
    date_by: getFilters("sale_date", "invoice_date")
  }
};

const updateFiltersListByIndex = (list, index, updater) =>
  list.map((item, idx) => (idx === index ? updater(item) : item));

const updateMainSelectedFilters = (state, updates) => ({
  ...state.mainFilters,
  selectedFilters: {
    ...state.mainFilters.selectedFilters,
    ...updates
  }
});

const createSelectedFiltersFromConfig = (startFromData, config, defaultDates) => ({
  start_from: startFromData,
  filter_by: config.filter_by[0],
  ...(startFromData.id !== "lead" && {
    date_by: config?.date_by?.[0]
  }),
  selectedRequestDates: defaultDates
});

const initialState = {
  isLoading: true,
  filtersDirty: false,
  filterLoading: false,
  mainFilterLoading: false,
  isHideActions: false,
  tableLoading: false,
  isUpdating: false,
  initialRequest: false,
  currentUser: {},
  isSelectedAction: false,
  startFromOptions: [
    { id: "appointment", name: "Appointment" },
    { id: "show", name: "Show" },
    { id: "enrollment", name: "Enrollment" }
  ],
  tableData: {},
  mainFilters: {
    start_from: [
      { id: "lead", name: "Lead" }
      // { id: "appointment", name: "Appointment" },
      // { id: "enrollment", name: "Enrollment" },
      // { id: "show", name: "Show" }
    ],
    condition: [
      { id: "and", name: "And" },
      { id: "or", name: "Or" }
    ],
    filter_by: [
      { id: "prospect_type", name: "Prospect Type" },
      { id: "referral_source", name: "Referral Source" },
      { id: "referral_category", name: "Referral Category" }
    ],
    date_by: [],
    filter_by_values: [],
    selectedFilters: {
      condition: { id: "and", name: "And" },
      start_from: { id: "lead", name: "Lead" },
      filter_by: { id: "prospect_type", name: "Prospect Type" },
      selectedRequestDates: {}
    }
  },
  datesByDefault: {},
  filtersList: []
};

export default handleActions(
  {
    [SET_DATES]: (state, { payload }) => ({
      ...state,
      mainFilters: updateMainSelectedFilters(state, { selectedRequestDates: payload }),
      datesByDefault: payload
    }),
    [SET_TABLE_LOADING]: (state, { payload }) => ({
      ...state,
      tableLoading: payload,
      filtersDirty: false
    }),
    [CHANGE_ORDER]: (state, action) => {
      const { index, direction } = action.payload;
      const newIndex = direction === "up" ? index - 1 : index + 1;

      if (newIndex < 0 || newIndex >= state.filtersList.length) {
        return state;
      }

      const list = [...state.filtersList];
      const temp = list[index];
      list[index] = list[newIndex];
      list[newIndex] = temp;

      return {
        ...state,
        filtersList: list
      };
    },
    [SET_LOADING]: (state, { payload }) => ({ ...state, isLoading: payload }),
    [SET_FILTERS_LOADING]: (state, { payload }) => ({ ...state, filterLoading: payload }),
    [SET_HIDE_ACTIONS]: (state, { payload }) => ({ ...state, isHideActions: payload }),
    [SET_MAIN_FILTER_LOADING]: (state, { payload }) => ({ ...state, mainFilterLoading: payload }),
    [FETCH_TABLE_DATA_SUCCESS]: (state, { payload }) => ({
      ...state,
      tableData: payload,
      isSelectedAction: true
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, { payload }) => ({
      ...state,
      initialRequest: true,
      currentUser: payload
    }),
    [SET_START_FROM]: (state, { payload }) => {
      const selectedStartFrom = payload.data;
      const config = FILTERS_CONFIG[selectedStartFrom.id];
      const startFromOptions =
        selectedStartFrom.id === "enrollment"
          ? state.mainFilters.start_from
          : state.mainFilters.start_from.filter((elem) => elem.id !== selectedStartFrom.id);

      return {
        ...state,
        startFromOptions,
        mainFilters: {
          ...state.mainFilters,
          ...config,
          selectedFilters: {
            ...state.mainFilters.selectedFilters,
            filter_by: config.filter_by[0],
            ...(selectedStartFrom.id !== "lead" && {
              date_by: config.date_by[0]
            }),
            start_from: selectedStartFrom
          }
        },
        filtersList: [],
        filtersDirty: false,
        isHideActions: false,
        isSelectedAction: false,
        tableData: {}
      };
    },
    [SET_FILTER_BY_INDEX]: (state, { payload }) => ({
      ...state,
      filtersList: updateFiltersListByIndex(state.filtersList, payload.index, (item) => ({
        ...item,
        selectedFilters: {
          ...item.selectedFilters,
          [payload.key]: payload.data
        }
      })),
      filtersDirty: true
    }),
    [FETCH_FILTER_BY_INDEX_SUCCESS]: (state, { payload }) => ({
      ...state,
      filtersList: updateFiltersListByIndex(state.filtersList, payload.index, (item) => ({
        ...item,
        filter_by_values: payload.filter_by_values,
        selectedFilters: {
          ...item.selectedFilters,
          filter_by_values: payload.filter_by_values
        }
      })),
      filtersDirty: true
    }),
    [SET_START_FROM_BY_INDEX]: (state, { payload }) => ({
      ...state,
      filtersList: updateFiltersListByIndex(state.filtersList, payload.index, (item) => {
        const config = FILTERS_CONFIG[payload.data.id];

        return {
          ...item,
          ...config,
          selectedFilters: {
            ...item.selectedFilters,
            start_from: payload.data,
            filter_by: config.filter_by[0],
            ...(payload.data.id !== "lead" && {
              date_by: config.date_by[0]
            })
          }
        };
      }),
      filtersDirty: true
    }),
    [CREATE_FILTERS_GROUP]: (state, { payload }) => {
      const config = FILTERS_CONFIG[payload.id];
      return {
        ...state,
        filtersList: [
          ...state.filtersList,
          {
            ...config,
            selectedFilters: createSelectedFiltersFromConfig(payload, config, state.datesByDefault)
          }
        ],
        filtersDirty: true,
        isHideActions: false
      };
    },
    [REMOVE_FILTERS_GROUP]: (state, { payload }) => {
      const updatedList = state.filtersList.filter((_, idx) => idx !== payload);
      return {
        ...state,
        filtersList: updatedList,
        filtersDirty: updatedList.length > 0,
        tableData: updatedList.length ? state.tableData : [],
        isSelectedAction: updatedList.length,
        mainFilters: {
          ...state.mainFilters,
          selectedFilters: {
            ...state.mainFilters.selectedFilters
          }
        }
      };
    },
    [FETCH_MAIN_FILTER_SUCCESS]: (state, { payload }) => ({
      ...state,
      mainFilters: {
        ...state.mainFilters,
        ...payload,
        selectedFilters: {
          ...state.mainFilters.selectedFilters,
          ...payload
        }
      }
    }),
    [UPDATE_MAIN_FILTER]: (state, { payload }) => ({
      ...state,
      filtersDirty: !!state.filtersList.length,
      mainFilters: updateMainSelectedFilters(state, {
        [payload.key]: payload.data
      }),
      isHideActions: false
    }),
    [RESET_FILTERS]: (state) => ({
      ...state,
      filtersList: [],
      filtersDirty: false,
      mainFilters: {
        ...initialState.mainFilters,
        selectedFilters: {
          ...initialState.mainFilters.selectedFilters,
          selectedRequestDates: state.datesByDefault
        }
      },
      tableData: [],
      isSelectedAction: initialState.isSelectedAction,
      startFromOptions: initialState.startFromOptions,
      isHideActions: initialState.isHideActions
    })
  },
  initialState
);
